export default {
	name: "schedule-delivery-orders-for-delivery",
	props:{
		orderDeliveryScheduleId: {
			default: null
		}
	},
	data() {
		return {
			orders: [],
			vehicles: [],
			drivers: [],
			vehicleCompartments: [],
			billingAddress: {},
			shippingAddress: {},
			currentOrder: {},
			currentOrderIndex: 0,
			schedulingDetails:{
				vehicleId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				driverId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				dateOfDeparture: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				expectedDateOfDelivery: {
					value: null,
					hasError: false,
					errorMessage: null,
					viewValue: null
				},
				sbo: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicle: null,
				driver: null
			},
			rescheduleModal: {
				showModal: false,
				isSaving: false,
				modalMessage: null,
				elementId: "rescheduleDeliveryOrdersForDeliveryModal",
				modalHeading: "Reschedule Orders For Delivery"
			},
			loading: false,
			loadingBillingAddress: false,
			assignedCompartments:{
				compartments: [],
				showAssignCompartmentModal: false,
				orderItem: null,
			},
			orderDeliveryVehicleCompartmentProductsSummary: [],
			notAllOrdersHaveCompartmentsAssignedMessage: null,
			successModal: {
				showModal: false,
				modalMessage: null,
				elementId: "scheduleDeliveryOrdersForDeliverySuccessModal",
				modalHeading: null
			},
			viewOnly: false,
			showCancelBatchButton: false,
			orderDeliveryScheduleSummary:{
				orderDeliveryScheduleAndOrderDeliveries: [],
				vehicleCompartmentProductAssignedSummaries: [],
			},
			initialiseExpectedDateOfDelivery: true,
			confirmDeliveryBatchCancelModal: {
				showModal: false,
				isSaving: false,
				modalMessage: "Are you sure you want to cancel this delivery batch?",
				elementId: "confirmDeliveryBatchCancelModal",
				modalHeading: "Confirm Cancellation Of Delivery Batch"
			},
			hasLoadedVehicleCompartments: false
		};
	},
	methods: {
		getOrdersSelectedForScheduling(){
			this.loading = true;
			this.orders = localStorageCacheHelper.getSelectedDeliveryOrdersForScheduling();
			if(this.orders === null || this.orders.length === 0){
				this.$router.replace("/orders/delivery");
			}
			else {
				for (var i = 0; i < this.orders.length; i++) {
					this.orders[i].isCurrentOrder = i === 0;
					if(this.orders[i].isCurrentOrder){
						this.currentOrder = this.orders[i];
					}
				}
				this.orders.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
				var self = this;
				setTimeout(function (){
					self.schedulingDetails.expectedDateOfDelivery.value = moment(self.orders[0].expectedDeliveryDate, 'DD/MM/YYYY')
				}, 500)
				this.getAddressesForCurrentOrder();
			}
			this.loading = false;
		},
		getDrivers(){
			this.loading = true;
			let request = {
				isActive: true
			};
			systemService.getAllDrivers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.drivers = successResponse.data.result;
						this.drivers = dataTableHelper.castFieldValues(this.drivers);
						this.drivers = $.map(this.drivers,
							function (obj) {
								obj.id = obj.id || obj.driverId;
								obj.text = obj.text || obj.firstName + " " + obj.lastName + "(" + obj.driverId + ")";
								return obj;
							});
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getVehicles(){
			this.loading = true;
			let request = {
				isActive: true
			};
			systemService.getAllVehicles(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.vehicles = successResponse.data.result;
						this.vehicles = dataTableHelper.castFieldValues(this.vehicles);
						this.vehicles = $.map(this.vehicles,
							function (obj) {
								obj.id = obj.id || obj.vehicleId;
								obj.text = obj.text || obj.fleetNumber;
								return obj;
							});
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerShippingAddresses(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.currentOrder.shippingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.shippingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.currentOrder.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getAddressesForCurrentOrder(){
			this.getCustomerShippingAddresses();
			this.getCustomerBillingAddress();
		},
		getOrderDeliveryVehicleCompartmentProductsSummaryForOrderDelivery(){
			this.loading = true;
			let request = {
				orderDeliveryId: this.currentOrder.orderDeliveryId,
				vehicleId: this.schedulingDetails.vehicleId.value,
				orderDeliveryScheduleId: null
			};
			orderService.getOrderDeliveryVehicleCompartmentProductsSummaryForOrderDelivery(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderDeliveryVehicleCompartmentProductsSummary = successResponse.data.orderDeliveryVehicleCompartmentProducts;
						this.hasLoadedVehicleCompartments = true;
						this.updateCompartmentSummary();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDeliveryOrderScheduleSummary(){
			orderService.getDeliveryOrderScheduleSummary(this.orderDeliveryScheduleId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries = successResponse.data.orderDeliveryScheduleAndOrderDeliveries;
						this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
						
						this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries = dataTableHelper.castFieldValues(this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries);
						
						this.orderDeliveryScheduleSummary.vehicleCompartmentProductAssignedSummaries = successResponse.data.vehicleCompartmentProductAssignedSummaries;
						this.assignedCompartments.compartments = this.orderDeliveryScheduleSummary.vehicleCompartmentProductAssignedSummaries;
						
						this.schedulingDetails.driver = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[0].driverName;
						this.schedulingDetails.vehicle = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[0].vehicle;
						this.schedulingDetails.vehicleId.value = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[0].vehicleId;
						this.schedulingDetails.driverId.value = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[0].driverId;
						this.schedulingDetails.expectedDateOfDelivery.viewValue = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[0].expectedDeliveryDate;
						this.schedulingDetails.dateOfDeparture.value = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[0].departureDate;
						this.schedulingDetails.sbo.value = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[0].sbo;
						
						for(let i = 0; i < this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries.length; i++){
							this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[i].isCurrentOrder = i === 0;
							if(this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[i].isCurrentOrder){
								this.currentOrder = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[i];
								this.showCancelBatchButton = this.currentOrder.orderStatusId !== orderHelper.orderStatus.complete
							}
						}
						console.log("currentOrderIndex", this.currentOrderIndex);
						console.log("orderDeliveryScheduleAndOrderDeliveries", this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries);
						this.getOrderDeliveryVehicleCompartmentProductsSummaryForOrderDelivery();
						this.getAddressesForCurrentOrder();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getVehicleCompartments(){
			this.loading = true;
			let request = {
				vehicleId: this.schedulingDetails.vehicleId.value
			};
			this.vehicleCompartments = [
				{
					vehicleCompartmentId: 1,
					compartmentNumber: 1,
					compartmentCapacity: 1000,
					
				}
			]
			// systemService.getVehicleCompartments(request).then(
			// 	successResponse => {
			// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
			// 		if(isSuccess){
			// 			this.vehicleCompartments = successResponse.data.result;
			// 			this.vehicleCompartments = dataTableHelper.castFieldValues(this.vehicleCompartments);
			// 		}
			// 		this.loading = false;
			// 	},
			// 	errorResponse => {
			// 		console.log("error", errorResponse);
			// 		this.loading = false;
			// 		apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
			// 	}
			// );
		},
		onCancelDeliveryBatchClick(){
			this.confirmDeliveryBatchCancelModal.showModal = true;
		},
		onCancelDeliveryBatchConfirm(cancel){
			if(cancel){
				this.cancelDeliveryBatch();
			}	
		},
		onVehicleSelect(vehicle){
			if(this.schedulingDetails.vehicleId.value !== vehicle.id){
				this.schedulingDetails.vehicleId.value = vehicle.id;
			}
			this.getOrderDeliveryVehicleCompartmentProductsSummaryForOrderDelivery();

		},
		onDriverSelect(driver){
			if(this.schedulingDetails.driverId.value !== driver.id){
				this.schedulingDetails.driverId.value = driver.id;
			}
			//this.schedulingDetails.driverId.value = driver.driverId;
		},
		onDateOfDepartureSelect(date){
			this.schedulingDetails.dateOfDeparture.value = date;
		},
		onExpectedDateOfDeliverySelect(date){
			this.initialiseExpectedDateOfDelivery = false;
			this.schedulingDetails.expectedDateOfDelivery.value = date;
		},
		onPreviousOrderClick(){
			if(!this.viewOnly){
				let currentIndex = this.orders.findIndex(order => order.isCurrentOrder);
				if(currentIndex > 0){
					this.orders[currentIndex].isCurrentOrder = false;
					this.orders[currentIndex - 1].isCurrentOrder = true;
					this.currentOrder = this.orders[currentIndex - 1];
					this.currentOrderIndex = currentIndex - 1;
					this.getAddressesForCurrentOrder();
				}
			}
			else{
				let currentIndex = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries.findIndex(order => order.isCurrentOrder);
				if(currentIndex > 0){
					this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[currentIndex].isCurrentOrder = false;
					this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[currentIndex - 1].isCurrentOrder = true;
					this.currentOrder = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[currentIndex - 1];
					this.currentOrderIndex = currentIndex - 1;
					this.getAddressesForCurrentOrder();
				}
			}
			this.updateCompartmentSummary();
		},
		onNextOrderClick(){
			if(!this.viewOnly){
				let currentIndex = this.orders.findIndex(order => order.isCurrentOrder);
				if(currentIndex < this.orders.length - 1){
					this.orders[currentIndex].isCurrentOrder = false;
					this.orders[currentIndex + 1].isCurrentOrder = true;
					this.currentOrder = this.orders[currentIndex + 1];
					this.currentOrderIndex = currentIndex + 1;
					this.getAddressesForCurrentOrder();
				}
			}
			else{
				let currentIndex = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries.findIndex(order => order.isCurrentOrder);
				if(currentIndex < this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries.length - 1){
					this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[currentIndex].isCurrentOrder = false;
					this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[currentIndex + 1].isCurrentOrder = true;
					this.currentOrder = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[currentIndex + 1];
					this.currentOrderIndex = currentIndex + 1;
					this.getAddressesForCurrentOrder();
				}
			}
			this.updateCompartmentSummary();
		},
		onOrderClick(order){
			if(!this.viewOnly){
				let newIndex = this.orders.findIndex(o => o.orderId === order.orderId);
				this.orders[this.currentOrderIndex].isCurrentOrder = false;
				order.isCurrentOrder = true;
				this.currentOrder = order;
				this.currentOrderIndex = newIndex;
				this.getAddressesForCurrentOrder();
			}
			else{
				let newIndex = this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries.findIndex(o => o.orderId === order.orderId);
				this.orderDeliveryScheduleSummary.orderDeliveryScheduleAndOrderDeliveries[this.currentOrderIndex].isCurrentOrder = false;
				order.isCurrentOrder = true;
				this.currentOrder = order;
				this.currentOrderIndex = newIndex;
				this.getAddressesForCurrentOrder();
			}
			this.updateCompartmentSummary();
		},
		onAssignCompartments(orderItem){
			this.assignedCompartments.orderItem = orderItem;
			this.assignedCompartments.showAssignCompartmentModal = true;
		},
		onSelectVehicleCompartmentsForOrderModalClose(){
			this.assignedCompartments.showAssignCompartmentModal = false;
		},
		openRescheduleModal(){
			this.rescheduleModal.showModal = true;
		},
		onRescheduleSaveClick(){
			this.rescheduleModal.isSaving = true;
			let request = {
				orderDeliveryScheduleId: this.orderDeliveryScheduleId,
				driverId: this.schedulingDetails.driverId.value,
				expectedDeliveryDate: this.schedulingDetails.expectedDateOfDelivery.value,
			};
			orderService.rescheduleDeliveryBatch(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.validationResponse.valuesAreValid) {
							this.rescheduleModal.showModal = false;
							var self = this;
							setTimeout(function (){
								self.successModal.showModal = true;
								self.successModal.modalMessage = "Delivery Batch has been rescheduled.";
								self.successModal.modalHeading = "Success";
							}, 500);
						}
						else{
							this.schedulingDetails.expectedDateOfDelivery.hasError = successResponse.data.validationResponse.expectedDateOfDeliveryValidationResponse.hasError;
							this.schedulingDetails.expectedDateOfDelivery.errorMessage = successResponse.data.validationResponse.expectedDateOfDeliveryValidationResponse.message;
							
							this.schedulingDetails.vehicleId.hasError = successResponse.data.validationResponse.vehicleIdValidationResponse.hasError;
							this.schedulingDetails.vehicleId.errorMessage = successResponse.data.validationResponse.vehicleIdValidationResponse.message;
							
							this.schedulingDetails.driverId.hasError = successResponse.data.validationResponse.driverIdValidationResponse.hasError;
							this.schedulingDetails.driverId.errorMessage = successResponse.data.validationResponse.driverIdValidationResponse.message;
						}
					}
					this.rescheduleModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.rescheduleModal.isSaving = false;
					this.rescheduleModal.showModal = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onCompartmentSave(selectedCompartments){
			this.assignedCompartments.showAssignCompartmentModal = false;
			var compartment = this.assignedCompartments.compartments.find(order => order.orderId === this.currentOrder.orderId);
			if(compartment) {
				compartment.selectedCompartments = selectedCompartments;
			}
			else {
				this.assignedCompartments.compartments.push({
					selectedCompartments: selectedCompartments,
					orderId: this.currentOrder.orderId,
					orderDeliveryId: this.currentOrder.orderDeliveryId,
					sequenceNumber: this.currentOrder.sequenceNumber,
					companyId: this.currentOrder.companyId
				});
			}
			this.updateCompartmentSummary();
		},
		updateCompartmentSummary(){
			// update summary
			if(!this.viewOnly){
				for(let i = 0; i < this.orderDeliveryVehicleCompartmentProductsSummary.length; i++) {
					this.orderDeliveryVehicleCompartmentProductsSummary[i].instructedQuantity = 0;
					this.orderDeliveryVehicleCompartmentProductsSummary[i].percentageOfMaxCapacity = 0;
					this.orderDeliveryVehicleCompartmentProductsSummary[i].upliftedQuantity = null;
					for (let j = 0; j < this.assignedCompartments.compartments.length; j++) {
						for (let k = 0; k < this.assignedCompartments.compartments[j].selectedCompartments.length; k++) {
							if (this.orderDeliveryVehicleCompartmentProductsSummary[i].vehicleCompartmentProductId === this.assignedCompartments.compartments[j].selectedCompartments[k].compartmentProduct.vehicleCompartmentProductId) {
								this.orderDeliveryVehicleCompartmentProductsSummary[i].instructedQuantity += this.assignedCompartments.compartments[j].selectedCompartments[k].assignedAmount;
								this.orderDeliveryVehicleCompartmentProductsSummary[i].percentageOfMaxCapacity = (this.orderDeliveryVehicleCompartmentProductsSummary[i].instructedQuantity / this.orderDeliveryVehicleCompartmentProductsSummary[i].compartmentMaxCapacity) * 100;
							}
						}
					}
				}
			}
			else{
				for(let i = 0; i < this.orderDeliveryVehicleCompartmentProductsSummary.length; i++) {
					this.orderDeliveryVehicleCompartmentProductsSummary[i].instructedQuantity = 0;
					this.orderDeliveryVehicleCompartmentProductsSummary[i].percentageOfMaxCapacity = 0;
					this.orderDeliveryVehicleCompartmentProductsSummary[i].upliftedQuantity = null;
					for (let j = 0; j < this.assignedCompartments.compartments.length; j++) {
						if (this.orderDeliveryVehicleCompartmentProductsSummary[i].vehicleCompartmentProductId === this.assignedCompartments.compartments[j].vehicleCompartmentProductId
							&& this.currentOrder.orderId === this.assignedCompartments.compartments[j].orderId) {
							this.orderDeliveryVehicleCompartmentProductsSummary[i].instructedQuantity += this.assignedCompartments.compartments[j].instructedQuantity;
							this.orderDeliveryVehicleCompartmentProductsSummary[i].percentageOfMaxCapacity = (this.orderDeliveryVehicleCompartmentProductsSummary[i].instructedQuantity / this.orderDeliveryVehicleCompartmentProductsSummary[i].compartmentMaxCapacity) * 100;
							this.orderDeliveryVehicleCompartmentProductsSummary[i].upliftedQuantity = this.assignedCompartments.compartments[j].upliftedQuantity;
						}
					}
				}
			}
			console.log("orderDeliveryVehicleCompartmentProductsSummary", this.orderDeliveryVehicleCompartmentProductsSummary);
		},
		validateScheduleOrderForDeliverySubmit(){
			var hasError = false;
			if(this.schedulingDetails.vehicleId.value == null){
				this.schedulingDetails.vehicleId.hasError = true;
				this.schedulingDetails.vehicleId.errorMessage = "Vehicle is required";
				hasError = true;
			}
			else{
				this.schedulingDetails.vehicleId.hasError = null;
				this.schedulingDetails.vehicleId.errorMessage = null;
			}

			if(this.schedulingDetails.driverId.value === null){
				this.schedulingDetails.driverId.hasError = true;
				this.schedulingDetails.driverId.errorMessage = "Driver is required";
				hasError = true;
			}
			else{
				this.schedulingDetails.driverId.hasError = null;
				this.schedulingDetails.driverId.errorMessage = null;
			}

			if(this.schedulingDetails.expectedDateOfDelivery.value === null || this.schedulingDetails.expectedDateOfDelivery.value === ""){
				this.schedulingDetails.expectedDateOfDelivery.hasError = true;
				this.schedulingDetails.expectedDateOfDelivery.errorMessage = "Expected Date of Delivery is required";
				hasError = true;
			}
			else{
				this.schedulingDetails.expectedDateOfDelivery.hasError = null
				this.schedulingDetails.expectedDateOfDelivery.errorMessage = null;
			}

			if(this.schedulingDetails.dateOfDeparture.value === null || this.schedulingDetails.dateOfDeparture.value === ""){
				this.schedulingDetails.dateOfDeparture.hasError = true;
				this.schedulingDetails.dateOfDeparture.errorMessage = "Date of Departure is required";
				hasError = true;
			}
			else{
				this.schedulingDetails.dateOfDeparture.hasError = null;
				this.schedulingDetails.dateOfDeparture.errorMessage = null;
			}

			var allOrdersHaveAssignedCompartments = true;
			if(this.assignedCompartments.compartments === null || this.assignedCompartments.compartments.length === 0){
				this.notAllOrdersHaveCompartmentsAssignedMessage = "Not all orders have compartments assigned.";
			}
			for(let j = 0; j < this.orders.length; j++){
				var orderHasCompartment = this.assignedCompartments.compartments.find(order => order.orderId === this.orders[j].orderId);
				if(!orderHasCompartment){
					allOrdersHaveAssignedCompartments = false;
					break;
				}
			}
			if(!allOrdersHaveAssignedCompartments){
				this.notAllOrdersHaveCompartmentsAssignedMessage = "Not all orders have compartments assigned.";
				hasError = true;
			}

			if(!hasError){
				this.notAllOrdersHaveCompartmentsAssignedMessage = null;
				this.scheduleOrdersForDelivery();
			}
		},
		scheduleOrdersForDelivery(){
			this.schedulingDetails.sbo.hasError = false;
			this.schedulingDetails.sbo.errorMessage = null;
			this.notAllOrdersHaveCompartmentsAssignedMessage = null;
			this.loading = true;
			var orderDeliveryVehicleCompartmentProducts = [];
			for(let i = 0; i < this.assignedCompartments.compartments.length; i++){
				for(let j = 0; j < this.assignedCompartments.compartments[i].selectedCompartments.length; j++){
					orderDeliveryVehicleCompartmentProducts.push({
						orderId: this.assignedCompartments.compartments[i].orderId,
						orderDeliveryId: this.assignedCompartments.compartments[i].orderDeliveryId,
						sequenceNumber: this.assignedCompartments.compartments[i].sequenceNumber,
						vehicleCompartmentProductId: this.assignedCompartments.compartments[i].selectedCompartments[j].compartmentProduct.vehicleCompartmentProductId,
						productId: this.assignedCompartments.compartments[i].selectedCompartments[j].productId,
						instructedQuantity: this.assignedCompartments.compartments[i].selectedCompartments[j].assignedAmount,
						companyId: this.assignedCompartments.compartments[i].companyId
					});
				}
			}
			let request = {
				vehicleId: this.schedulingDetails.vehicleId.value,
				driverId: this.schedulingDetails.driverId.value,
				expectedDateOfDelivery: this.schedulingDetails.expectedDateOfDelivery.value,
				dateOfDeparture: this.schedulingDetails.dateOfDeparture.value,
				sbo: this.schedulingDetails.sbo.value,
				orderDeliveryVehicleCompartmentProducts: orderDeliveryVehicleCompartmentProducts,
			};
			orderService.addOrUpdateOrderDeliverySchedule(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.sboAlreadyExists){
							this.schedulingDetails.sbo.hasError = true;
							this.schedulingDetails.sbo.errorMessage = "SBO already exists.";
						}
						else{
							if(successResponse.data.scheduleOrderValidationResponse.valuesAreValid){
								this.successModal.showModal = true;
								this.successModal.modalMessage = "Orders have been scheduled for delivery.";
								this.successModal.modalHeading = "Success";
								localStorageCacheHelper.removeSelectedOrdersForSchedulingCache();
							}
							else{
								this.schedulingDetails.dateOfDeparture.hasError = successResponse.data.scheduleOrderValidationResponse.dateOfDepartureValidationResponse.hasError;
								this.schedulingDetails.dateOfDeparture.errorMessage = successResponse.data.scheduleOrderValidationResponse.dateOfDepartureValidationResponse.message;

								this.schedulingDetails.expectedDateOfDelivery.hasError = successResponse.data.scheduleOrderValidationResponse.expectedDateOfDeliveryValidationResponse.hasError;
								this.schedulingDetails.expectedDateOfDelivery.errorMessage = successResponse.data.scheduleOrderValidationResponse.expectedDateOfDeliveryValidationResponse.message;
							}
						}
						
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		cancelDeliveryBatch(){
			this.confirmDeliveryBatchCancelModal.isSaving = true;
			this.loading = true;
			let request = {
				orderDeliveryScheduleId: this.orderDeliveryScheduleId
			};
			orderService.cancelOrderDeliverySchedule(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						var self = this;
						setTimeout(function (){
							self.successModal.showModal = true;
							self.successModal.modalMessage = "Delivery Batch has been cancelled.";
							self.successModal.modalHeading = "Success";
						}, 500)
						
					}
					this.loading = false;
					this.confirmDeliveryBatchCancelModal.isSaving = false;
					this.confirmDeliveryBatchCancelModal.showModal = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					this.confirmDeliveryBatchCancelModal.isSaving = false;
					this.confirmDeliveryBatchCancelModal.showModal = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		successModelOkClicked(){
			this.successModal.showModal = false;
			this.$router.replace("/orders/delivery");
		},
		setBreadcrumbs() {
			var pageTitle = "Schedule Orders For Delivery";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		permissionsHelper.setControlsBasedOnPermissions();
		// this.getOrdersSelectedForScheduling();
		this.getVehicles();
		this.getDrivers();
	},
	watch:{
		orderDeliveryScheduleId:{
			handler: function(){
				console.log("orderDeliveryScheduleId", this.orderDeliveryScheduleId);
				if(this.orderDeliveryScheduleId !== null && this.orderDeliveryScheduleId !== ""){
					this.viewOnly = true;
					this.getDeliveryOrderScheduleSummary();
				}
				else{
					this.viewOnly = false;
					this.getOrdersSelectedForScheduling();
				}
			},
			immediate: true,
			deep: true
		}
	}
};